import { render } from "./personalMessage.vue?vue&type=template&id=897928f6&scoped=true&ts=true"
import script from "./personalMessage.vue?vue&type=script&lang=ts"
export * from "./personalMessage.vue?vue&type=script&lang=ts"

import "../../forum/css/antd.css?vue&type=style&index=0&lang=css"
import "./personalMessage.vue?vue&type=style&index=1&id=897928f6&scoped=true&lang=scss"

import exportComponent from "D:\\SVNwork\\01_工程区\\01_代码\\RPAPortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897928f6"]])

export default __exports__